function getAppsBackend() {
  return "https://apps-backend.iota.cafe";
}
export {
  getAppsBackend
};
//# sourceMappingURL=apps-backend.js.map
